import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import FloatingActionButton, { FabPosition } from '../../components/floating_action_button'
import Header from '../../components/header'
import { SnackbarTypes } from '../../components/snackbar'
import SongItem, { SongItemPages } from '../../components/songItem'
import Song, { instanceOfSong } from '../../entities/song'
import { UserType } from '../../entities/user'
import { useClub } from '../../providers/clubProvider'
import { useCommonComponents } from '../../providers/commonComponentsProvider'
import { useAuth } from '../../providers/userProvider'
import NetworkService from '../../services/networkService'
import { API_ENDPOINTS } from '../../utils/apiEndpoints'
import { RoutesKeys } from '../../utils/routes'
import './index.scss'

const ClubSongsList = () => {
    const {club, clubSongsList, updateClubSongs} = useClub()
    const navigate = useNavigate()
    const {user} = useAuth()
    const {showSnackbar, showLoader, hideLoader} = useCommonComponents()
    const fetchClubSongs = async () => {
        showLoader(null)
        try{
            const data = await NetworkService.get({
                url: API_ENDPOINTS.clubSongs,
                data:{
                    clubId:club?.clubId,
                }
            })
            hideLoader()
            if(Array.isArray(data)){
                if(!data.length) updateClubSongs([])
                else if(instanceOfSong(data[0])) updateClubSongs(data)
            } else {
                showSnackbar({
                    children:<span>Cound not fetch club songs</span>,
                    type:SnackbarTypes.ERROR
                })
            }
        } catch(err){
            hideLoader()
            showSnackbar({
                children:<span>Cound not fetch club songs</span>,
                type:SnackbarTypes.ERROR
            })
        }
    }
    const removeClubImages = () => {
        if(club?.bannerUrl){
            document.body.style.removeProperty('background-image')
        }
    }
    const handleClubImages = () => {
        if(club?.bannerUrl){
            document.body.style.backgroundImage = `url(${club.bannerUrl})`
        }
    }
    useEffect(() => {
        if(!club){
            navigate(RoutesKeys.SELECT_CLUB, {
                replace:true
            })
        } else{
            fetchClubSongs()
            handleClubImages()
        }
        return ()=>{
            removeClubImages()
        }
    },[])
    const getSongs = () => {
        if(clubSongsList.length){
            return clubSongsList.map((song:Song) => <SongItem song={song} key={song.videoId} pageType={SongItemPages.SONGS_LIST} /> )
        } else{
            return <div className='empty-state'>No songs added yet</div>
        }
    }
    return (
        <>
            <Header pageName={`Songs list for ${club?.clubName}`} showBackButton={user?.user_type !== UserType.DJ} child={club?.logoUrl ? <img src={club.logoUrl} className='header-club-logo' alt='Logo' />: <></>} />
            <div className='songs-list-container container content'>
                {getSongs()}
            </div>
            { user && user.user_type === UserType.USER ? <FloatingActionButton position={FabPosition.left} onClick={() => navigate(RoutesKeys.SELECT_SONGS)}>Select songs</FloatingActionButton> : null}        
        </>
    )
}

export default ClubSongsList